export default __webpack_public_path__ + "static/media/coleta-mujer-pelirrojo.6179caaf.png";